<template>
  <div>
    <Component :is="pageComponent" :clients-see-more="clientsSeeMore"/>
    <HowMuchBlock/>

    <TryNewPlatformForm/>
  </div>
</template>

<script>
import LayoutPrimary from "@/mixins/LayoutPrimary";
import HowMuchBlock from "~/components/Common/HowMuchBlock.vue";
import TryNewPlatformForm from "~/components/Common/Form/TryNewPlatformForm.vue";
import ClientsBittnerPharmaDesktop from "~/components/Page/Clients/ClientsBittnerPharmaDesktop.vue";
import ClientsBittnerPharmaMobile from "~/components/Page/Clients/ClientsBittnerPharmaMobile.vue";

export default {
  components: {TryNewPlatformForm, HowMuchBlock},
  mixins: [LayoutPrimary],
  data() {
    return {
      clientsSeeMore: [
        {
          link: '/clients/lenovo/',
          skin: require('~/assets/img/clients-items/see-also/lenovo-skin.jpg'),
          skin_webp: require('~/assets/img/clients-items/see-also/lenovo-skin.webp'),
          title: 'Как Lenovo сокращает время на запуск новых продуктов',
          logo: require('~/assets/img/clients-items/see-also/lenovo-logo.png'),
          logo_webp: require('~/assets/img/clients-items/see-also/lenovo-logo.webp'),
        },
        {
          link: '/clients/fokus_media/',
          skin: require('~/assets/img/clients-items/see-also/fokus-media-skin.jpg'),
          skin_webp: require('~/assets/img/clients-items/see-also/fokus-media-skin.webp'),
          title: 'Как «Фокус-Медиа» проводит совещания с партнерами?',
          logo: require('~/assets/img/clients-items/see-also/fokus-media-logo.png'),
          logo_webp: require('~/assets/img/clients-items/see-also/fokus-media-logo.webp'),
        },
      ],
    }
  },
  head() {
    return {
      title: 'Клиент МТС Линк компания BITTNER PHARMA - МТС Линк',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Клиент МТС Линк компания BITTNER PHARMA',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Клиент, МТС Линк, компания «BITTNER PHARMA»',
        },
      ],
    };
  },
  computed: {
    pageComponent: (ctx) => ctx.$device.isDesktop ? ClientsBittnerPharmaDesktop : ClientsBittnerPharmaMobile,
  }
}
</script>
